module.exports = __webpack_public_path__ + "view/img/a5d5a7f6787f4b02a6f3e0b98342aa71.015a195.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/a5d5a7f6787f4b02a6f3e0b98342aa71.png
// module id = zPn0
// module chunks = 0